import React, { useEffect, useState } from 'react';
import { host_url } from '../../App'; // Import host_url
import './JobsKinder.css';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';

function JobsKinder() {
  const [einheiten, setEinheiten] = useState([]);

  const hasWarning = einheiten.some(e =>
    parseInt(e.JobsInEinheit, 10) < parseInt(e.KinderInEinheit, 10)
  );

  useEffect(() => {
    fetch(`${host_url}/einheit_details_with_jobs`)
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data)) {
          setEinheiten(data);
        } else {
          console.error('Expected an array but got:', data);
          setEinheiten([]);
        }
      })
      .catch(error => console.error('Error fetching einheit_details_with_jobs:', error));
  }, []);

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/arbeit" color="gelb" />
      <h1 className="section-title orange">Übersicht Anzahl Arbeitsplätze</h1>
      <main>
        <div className="jobsKinder-table-wrapper">
        <table className="jobsKinder-table">
          <thead>
            <tr>
              <th>Einheit</th>
              <th>Kinder mit Jobbedarf</th>
              <th>Arbeitsplätze</th>
              <th>Verteilte Jobs</th>
            </tr>
          </thead>
          <tbody>
            {einheiten.map(einheit => {
              const jobsInEinheit = parseInt(einheit.JobsInEinheit, 10);
              const kinderInEinheit = parseInt(einheit.KinderInEinheit, 10);
              const verteilteJobs = parseInt(einheit.VerteilteJobs, 10);
              const showWarning = jobsInEinheit < kinderInEinheit;
              return (
                <tr key={einheit.EinheitID}>
                  <td>{einheit.EinheitName}</td>
                  <td>{einheit.KinderInEinheit}</td>
                  <td className="jobs-count-cell">
                    {einheit.JobsInEinheit}
                    {showWarning && (
                      <span className="material-symbols-outlined warning-icon">warning</span>
                    )}
                  </td>
                  <td>{verteilteJobs}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {hasWarning && (
          <div className="warning-legend">
            <span className="material-symbols-outlined">warning</span>
            Hinweis: Hier gibt es eine hohe Nachfrage und zu wenig Arbeitsplätze.
          </div>
        )}
        </div>
      </main>
    </div>

    </KernteamLayout>
  );
}

export default JobsKinder;
